import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subscription } from "rxjs";
import { SelectColumns } from "src/app/_models/select.model";
import { SpaceAssignmentModel } from "src/app/_models/space-assignment.model";
import { GetAssignmentsModel } from "src/app/_models/space-requests.model";
import { User } from "src/app/_models/user.model";
import { AuthenticationService } from "src/app/_services";
import { BookingService } from "src/app/_services/booking.service";
import { ThisPlatform } from "src/app/_services/platform.service";
import { SpaceService } from "src/app/_services/space.service";
import { SpaceType } from "src/app/_types/space-type";
import { RoomFilterModalComponent } from "../../booking/room/room-filter-modal/room-filter-modal.component";
import { Building } from "../../building/building.model";
import { BuildingService } from "../../building/building.service";
import { EquipmentService } from "../../equipment/equipment.service";
import { SelectButton } from "../select-buttons/select-buttons.model";
import { preventSwipeToClose } from "src/app/_helpers/preventSwipeToClose";

@Component({
  selector: "app-select-with-images",
  templateUrl: "./select-with-images.component.html",
  styleUrls: ["./select-with-images.component.scss"],
})
export class SelectWithImagesComponent implements OnInit, OnDestroy {
  @Input()
  limitModal = 5;

  @Input()
  defaultImage: string;

  @Input()
  placeholder: string;

  @Input()
  name: string;

  private itemsFiltered: any[] = [];

  @Input()
  itemTextField: string;

  @Input()
  itemValueField: string;

  @Input()
  selectColumns: SelectColumns[];

  @Output()
  changeValue: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  actualValue: any;

  @Input()
  isImagesDisplay: boolean;

  @Input()
  displayItems: any[];

  @Input()
  editLink: string;

  @Input()
  itemsObservable: Observable<any>;

  @Input()
  initBuilding?: Building;

  actualSubscription: Subscription;
  itemsWith: any[];
  filteredItems: any[];
  itemsFilteredByDate: any[];
  public itemValue: string;
  public isSpinner: boolean;
  public itemName: string;
  private roomsFilter = [];
  parsedEquipments: SelectButton[] = [];
  cancelBtn = "Cancel";
  maximimCapacity: number;
  type = SpaceType.Room;
  equipmentFilters = [];
  idListOfAvaliableSpaces: number[];

  constructor(
    private translateServ: TranslateService,
    public p: ThisPlatform,
    public modalController: ModalController,
    private router: Router,
    public equipmentServ: EquipmentService,
    public buildingServ: BuildingService,
    public modalCtrl: ModalController,
    private bookingService: BookingService,
    private spaceService: SpaceService,
    private authenticationService: AuthenticationService
  ) {}

  async ngOnInit() {
    this.cancelBtn = this.translateServ.instant("CANCEL");
    if (typeof this.actualValue !== "undefined") {
      this.itemValue = this.actualValue;
    }
    await this.equipmentServ.loadEquipmentsSync(false, this.type);

    // if (!this.userService.hasRoles(this.editPermision)) {
    this.authenticationService.currentUser.subscribe(async (user: User) => {
      let getAssignmentParameters: GetAssignmentsModel = {
        spaceType: SpaceType.Room,
        endTimeGreatherThan: new Date().toISOString(),
      };

      this.spaceService
        .getAssignments(getAssignmentParameters)
        .subscribe((assignments: SpaceAssignmentModel[]) => {
          const filteredAssignments: SpaceAssignmentModel[] = assignments.filter(
            (assignment: SpaceAssignmentModel) => {
              return (
                (assignment.user === null || assignment.user?.id === user.id) &&
                (assignment.company === null || assignment.company?.id === user.company.id)
              );
            }
          );
          this.idListOfAvaliableSpaces = filteredAssignments.map(
            (assignment: SpaceAssignmentModel) => assignment.idSpace
          );

          this.itemsFilteredByDate = this.filterItemsByDate(this.displayItems);
          this.filteredItems = this.itemsFilteredByDate

          this.checkMaximumRoomCapacity(this.filteredItems);
        });
    });
    // } else {
    //    this.filteredItems = this.displayItems;
    //    this.checkMaximumRoomCapacity(this.filteredItems);
    // }



    this.parseEquipmentArray();

    this.actualSubscription = this.bookingService.filterDetailsSubject.subscribe(
      (equipmentListId) => {
        this.equipmentFilters = equipmentListId;
        this.onFilterEquipment(equipmentListId);
      }
    );
    this.itemsObservable.subscribe((e) => {
      this.itemsFilteredByDate = this.filterItemsByDate(e);
      this.onFilterEquipment(this.equipmentFilters);
    });
  }

  onFilterEquipment(equipmentListId) {
    if (equipmentListId && equipmentListId.length !== 0) {
      this.filteredItems = this.itemsFilteredByDate.filter((s) => {
        const equipmentsId = [];
        s.equipments.forEach((e) => {
          equipmentsId.push(e.id);
        });

        return equipmentListId.every((v) => equipmentsId.includes(v));
      });
    } else {
      this.filteredItems = this.itemsFilteredByDate;
    }
    this.bookingService.equipmentsCounter = this.filteredItems.length;
  }

  ngOnDestroy() {
    this.itemValue = this.actualValue;
  }

  onClicked(EVENT) {
    this.itemValue = EVENT;
    this.changeValue.emit(EVENT);
    return;
  }

  onEditLinkClick(id: number, event) {
    event.preventDefault();
    event.stopPropagation();
    this.router.navigateByUrl(this.editLink + id);
  }

  onChangeValue($event) {
    this.changeValue.emit($event);
    if (typeof this.actualValue !== "undefined") {
      this.itemValue = this.actualValue;
    }
  }

  onChangeSearch(data) {
    if (data && data.length > 0) {
      this.filteredItems = this.itemsFilteredByDate.filter((s) => {
        return (s.name + "").toUpperCase().includes(data.toUpperCase());
      });
    } else {
      this.filteredItems = this.itemsFilteredByDate;
    }
  }

  parseEquipmentArray() {
    this.equipmentServ.equipments.forEach((el) => {
      let singleEquipment = {
        value: el.id,
        key: el.name,
        equipmentIcon: el.iconName,
      };

      this.parsedEquipments.push(singleEquipment);
    });
  }

  checkMaximumRoomCapacity(roomList) {
    const capacityList = [];
    roomList.forEach((room) => {
      capacityList.push(room.capacity);
    });
    this.maximimCapacity = Math.max(...capacityList);
  }

  filterItemsByDate(itemsToBeFiltered) {
    return itemsToBeFiltered.filter((item) =>
      this.idListOfAvaliableSpaces.includes(item.id)
    );
  }

  async onToggleFilter() {
    const modal = await this.modalCtrl.create({
    component: RoomFilterModalComponent,
      componentProps: {
        page: "rooms",
        equipmentListId: this.equipmentFilters,
        initialBuilding: this.initBuilding
      },
      canDismiss: preventSwipeToClose,
      cssClass: "add-edit-modal mobile-filter__modal-container",
    });
    modal.present();
  }
}
